var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "selectSMB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Catalogue-des-Sources",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "selectSMB"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "server-(1)",
    transform: "translate(24.000000, 12.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66666667,0 L28.3333333,0 C29.2538079,0 30,0.651222182 30,1.45454545 L30,7.27272727 C30,8.07605055 29.2538079,8.72727273 28.3333333,8.72727273 L1.66666667,8.72727273 C0.746192084,8.72727273 0,8.07605055 0,7.27272727 L0,1.45454545 C0,0.651222182 0.746192084,0 1.66666667,0 M1.66666667,11.6363636 L28.3333333,11.6363636 C29.2538079,11.6363636 30,12.2875858 30,13.0909091 L30,18.9090909 C30,19.7124142 29.2538079,20.3636364 28.3333333,20.3636364 L1.66666667,20.3636364 C0.746192084,20.3636364 0,19.7124142 0,18.9090909 L0,13.0909091 C0,12.2875858 0.746192084,11.6363636 1.66666667,11.6363636 M1.66666667,23.2727273 L28.3333333,23.2727273 C29.2538079,23.2727273 30,23.9239495 30,24.7272727 L30,30.5454545 C30,31.3487778 29.2538079,32 28.3333333,32 L1.66666667,32 C0.746192084,32 0,31.3487778 0,30.5454545 L0,24.7272727 C0,23.9239495 0.746192084,23.2727273 1.66666667,23.2727273 M10,5.81818182 L11.6666667,5.81818182 L11.6666667,2.90909091 L10,2.90909091 L10,5.81818182 M10,17.4545455 L11.6666667,17.4545455 L11.6666667,14.5454545 L10,14.5454545 L10,17.4545455 M10,29.0909091 L11.6666667,29.0909091 L11.6666667,26.1818182 L10,26.1818182 L10,29.0909091 M3.33333333,2.90909091 L3.33333333,5.81818182 L6.66666667,5.81818182 L6.66666667,2.90909091 L3.33333333,2.90909091 M3.33333333,14.5454545 L3.33333333,17.4545455 L6.66666667,17.4545455 L6.66666667,14.5454545 L3.33333333,14.5454545 M3.33333333,26.1818182 L3.33333333,29.0909091 L6.66666667,29.0909091 L6.66666667,26.1818182 L3.33333333,26.1818182 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmb);
export default __webpack_public_path__ + "static/media/smb.86484a4763024e2843fb49462a97b1fd.svg";
export { ForwardRef as ReactComponent };